export default "__VITE_ASSET__DBhI5zh6__"